<template>
  <!-- <div class="check-exam-status" v-loading="loading"> -->
  <div class="check-exam-status" v-if="examInfo">
    <div class="exam-header">
      <el-row type="flex" justify="space-between">
        <el-col :span="8" class="exam-title">
          <!-- <h3>{{ examInfo.manageName }}</h3> -->
          <el-tooltip effect="light" :content="examInfo.manageName" placement="bottom">
            <h3>{{ examInfo.manageName }}</h3>
          </el-tooltip>
        </el-col>
        <el-col :span="8">
          <div class="goback" v-show="!dsf.cookies.get('isDd')">
            <div>
              <i class="iconfont icon-guanbi2" title="关闭" @click="closePage"></i>
              <span class="closeitem" @click="closePage">关闭</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="exam-main">
      <div class="status-wrapper">
        <div
          :class="{
            'status-info': true,
            success: examInfo.isPass === '1',
            failed: examInfo.isPass === '0',
            other: examInfo.isPass !== '1' || examInfo.isPass === '0',
          }"
        >
          <div class="exam-user">
            <div class="exam-user-photo">
              <el-avatar v-if="examInfo.userId" :size="100" :src="'/oua2/getUserPhoto?type=relativePath&userId=' + examInfo.userId"> </el-avatar>
            </div>
            <div class="exam-user-name">
              <span>{{ examInfo.userName }}</span>
            </div>
          </div>
          <el-tooltip class="item" effect="light" :content="examInfo.manageName" placement="top">
            <div class="exam-title">
              <p>{{ examInfo.manageName }}</p>
            </div>
          </el-tooltip>

          <div class="exam-dividing-line"></div>

          <div class="content" v-if="examInfo.status === '完成'">
            <div class="exam-scors-wrapperpass">
              <div>
                <span
                  :class="{
                    'exam-scors': true,
                    'exam-scors-pass': examInfo.isPass === '1',
                    'exam-scors-fail': examInfo.isPass === '0',
                  }"
                >
                  {{ examInfo.showText }}
                </span>
              </div>
            </div>

            <div class="exam-stars">
              <div class="icon_star_r icon_star">
                <img class="icon" v-if="examInfo.isPass === '1'" src="/static/img/icon_star_r.png" />
                <i class="icon iconfont icon-icon_star_r2" v-else-if="examInfo.isPass === '0'"></i>
              </div>
              <div class="icon_star_c icon_star">
                <img class="icon" v-if="examInfo.isPass === '1'" src="/static/img/icon_star_c.png" />
                <i class="icon iconfont icon-icon_star_c2" v-else-if="examInfo.isPass === '0'"></i>
              </div>
              <div class="icon_star_l icon_star">
                <img class="icon" v-if="examInfo.isPass === '1'" src="/static/img/icon_star_l.png" />
                <i class="icon iconfont icon-icon_star_l2" v-else-if="examInfo.isPass === '0'"></i>
              </div>
            </div>

            <div class="exam-status-pic" v-if="examInfo.isPass !== '不公布'">
              <img class="icon" v-if="examInfo.isPass === '1'" src="/static/img/icon_ytg.png" />
              <img class="icon" v-else-if="examInfo.isPass === '0'" src="/static/img/icon_wtg.png" />
            </div>
          </div>

          <div class="content" v-else>
            <div v-if="examInfo.status">
              <div class="exam-piyue-name">{{ examInfo.status }}</div>
              <div class="exam-piyue-tips">交卷成功，请等待成绩公布！</div>
            </div>
          </div>
        </div>

        <div class="exam-button-bar" v-if="examInfo.status">
          <router-link v-if="examInfo.status" class="exam-button-item" :to="'/pc/exam/exam-record?id=' + $route.query.recordId + '&type=record'">
            查看详情
          </router-link>
          <div class="exam-button-item" @click="tryAgain" v-if="examInfo.status !== '历史' && examInfo.remainNum !== '0'">
            <span>再考一次{{ examInfo.infinite === true ? "(不限次)" : "(" + examInfo.remainNum + "次)" }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExamStatus",
  data() {
    return {
      userId: "",
      examInfo: null,
      loading: false,
      wsStatus: null,
      timer:"",
    };
  },
  created() {},
  mounted() {
    // this.getPresentScore();
    // this.wsStatus = dsf.ws();
    // this.wsStatus.$on("/exam/handle/score", (res) => {
    //   if (res.data.recordId === this.$route.query.recordId) {
    //     this.examInfo = res.data;
    //   }
    // });
    // this.wsStatus.$send("/exam/handle/score", this.$route.query.recordId, true);
    this.getPresentScore();
    this.timer=setInterval(()=>{
      if(this.examInfo.status =="批阅中"){
        this.getPresentScore();
      }else{
        clearInterval(this.timer);  
      }
    },5000)
  },
  methods: {
    closePage() {
      window.close();
      window.history.go(-1);
    },
    tryAgain() {
      let url = location.pathname + "#/pc/exam/manage/examinfo?batchId=" + this.examInfo.batchId + "&share=0";
      location.replace(url);
      // window.open(url);
      // this.$router.replace({
      //   path: location.pathname"exam/manage/examinfo",
      //   query: {
      //     batchId: this.$route.query.batchId,
      //     share: 0,
      //   },
      // });
    },

    //查看分数
    getPresentScore() {
      // var loading = dsf.layer.loading();
      var { manageId, recordId } = this.$route.query;
      this.$http
        .get(
          "/record/getPresentScore",
          {
            manageId,
            recordId,
          },
          $$webRoot.exam
        )
        .done((res) => {
          if (res.success && res.state == 20000) {
              this.examInfo = res.data;
          } else {
            dsf.layer.message(res.message || "请求异常", false);
          }
        })
        .error((err) => {
          //错误
          dsf.layer.message(err.message || "请求异常", false);
        })
        .always(() => {
          // dsf.layer.closeLoading(loading);
        });
    },
  },
  beforeDestroy() {
    // this.wsStatus.$destroy();
    clearInterval(this.timer);
  },
};
</script>
